import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { EnderecoService } from 'src/app/services/endereco/endereco.service';
import { ToastService } from 'src/app/services/toast/toast.service';

@Component({
  selector: 'cadastro-endereco',
  templateUrl: './cadastro-endereco.component.html',
  styleUrls: ['./cadastro-endereco.component.css'],
  viewProviders:  [{ provide:  ControlContainer, useExisting:  NgForm }]
})
export class CadastroEnderecoComponent implements OnInit {


  @Input() dadosEndereco;
  @Input() obrigatorio = true;
  @Input() apresentaCopiarEndereco = false;
  @Output() copiarEndereco = new EventEmitter();

  public maskCep = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];

  constructor(private enderecoService: EnderecoService,
              private toastService: ToastService) { }

  ngOnInit() {
  }

  validaCep(cep) {
    const regex = /^\d{2}((?!000000).)*$/;
    return regex.test(cep);
  }

  enderecoBuilder(endereco) {
    if (endereco && endereco.sucesso) {
      this.dadosEndereco.uf       = endereco.uf;
      this.dadosEndereco.cidade   = endereco.localidade + ' ' + endereco.complemento;
      this.dadosEndereco.bairro   = endereco.bairro;
      this.dadosEndereco.endereco = endereco.logradouro;
      this.dadosEndereco.pontoReferencia = endereco.pontoReferencia;
    } else {
      this.dadosEndereco.uf       = null;
      this.dadosEndereco.cidade   = null;
      this.dadosEndereco.bairro   = null;
      this.dadosEndereco.endereco = null;
      this.toastService.showAlerta('Cep inexistente ou endereço não encontrado.');
    }
  }

  onChangeCep() {
    if (this.dadosEndereco.cep && this.validaCep(this.dadosEndereco.cep)) {
      this.enderecoService.getEnderecoPorCep(this.dadosEndereco.cep).subscribe(
          (dados) => {
            this.enderecoBuilder(dados);
          },
          (err) => {
            this.enderecoBuilder(null);
            this.toastService.showAlerta('Ocorreu um erro ao buscar o endereço.');
          }
        );
    }
  }

  copiarEnderecoBeneficiario() {
    this.copiarEndereco.emit();
  }

  onUfChange(uf: any) {
    this.dadosEndereco.uf = uf?.nome;
  }

}
